import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { AppLayout } from '../components/layout';
import { Card, Button } from '../components/ui';
import useRolesStore from '../stores/rolesStore';

const Roles = () => {
	const navigate = useNavigate();
	const { roles, deleteRole } = useRolesStore();
	const [searchTerm, setSearchTerm] = useState('');

	const filteredRoles = roles.filter(role =>
		role.name.toLowerCase().includes(searchTerm.toLowerCase())
	);

	const handleDelete = (id: string, name: string) => {
		if (
			window.confirm(
				`Are you sure you want to delete ${name} role? This action cannot be undone.`
			)
		) {
			const deletePromise = new Promise(resolve => {
				setTimeout(() => {
					deleteRole(id);
					resolve(true);
				}, 500);
			});

			toast.promise(deletePromise, {
				loading: 'Deleting role...',
				success: 'Role deleted successfully!',
				error: 'Failed to delete role',
			});
		}
	};

	return (
		<AppLayout>
			<div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 mb-6">
				<div className="w-full sm:w-auto">
					<h1 className="text-xl md:text-2xl font-bold text-gray-900 dark:text-gray-100">
						All Roles
					</h1>
					<div className="flex items-center gap-2 text-xs sm:text-sm text-gray-600 dark:text-gray-400 mt-2 flex-wrap">
						<span
							className="text-blue-600 dark:text-blue-400 cursor-pointer hover:underline"
							onClick={() => navigate('/dashboard')}
						>
							Dashboard
						</span>
						<span>›</span>
						<span
							className="text-blue-600 dark:text-blue-400 cursor-pointer hover:underline"
							onClick={() => navigate('/settings')}
						>
							Settings
						</span>
						<span>›</span>
						<span>Roles</span>
					</div>
				</div>
				<Button
					variant="primary"
					onClick={() => navigate('/roles/new')}
					className="w-full sm:w-auto"
				>
					+ Add New Role
				</Button>
			</div>

			<input
				type="text"
				className="w-full sm:max-w-sm px-3 sm:px-4 py-2.5 sm:py-3 rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-600 dark:focus:ring-blue-400 focus:border-transparent mb-6 text-sm sm:text-base"
				placeholder="Search roles..."
				value={searchTerm}
				onChange={e => setSearchTerm(e.target.value)}
			/>

			<Card>
				{filteredRoles.length === 0 ? (
					<div className="text-center py-12">
						<p className="text-gray-500 dark:text-gray-400">No roles found</p>
					</div>
				) : (
					<div className="space-y-3 md:space-y-4">
						{filteredRoles.map(role => (
							<div
								key={role.id}
								className="bg-white dark:bg-gray-700 p-4 md:p-5 rounded-lg shadow-sm hover:shadow-md transition-all hover:-translate-y-0.5"
							>
								<div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
									<div className="flex-1 min-w-0">
										<h3 className="text-lg sm:text-xl font-bold text-gray-900 dark:text-gray-100 mb-1 truncate">
											{role.name}
										</h3>
										<p className="text-xs sm:text-sm text-gray-600 dark:text-gray-400">
											⏱️ Duration: {role.duration}
										</p>
									</div>
									<div className="flex gap-2 w-full sm:w-auto">
										<Button
											variant="secondary"
											onClick={() => navigate(`/roles/${role.id}/edit`)}
											className="flex-1 sm:flex-none"
										>
											Edit
										</Button>
										<Button
											variant="danger"
											onClick={() => handleDelete(role.id, role.name)}
											className="flex-1 sm:flex-none"
										>
											Delete
										</Button>
									</div>
								</div>
							</div>
						))}
					</div>
				)}
			</Card>

			<div className="mt-6 text-sm text-gray-500 dark:text-gray-400 text-center">
				© Beauty Business Portal
			</div>
		</AppLayout>
	);
};

export default Roles;
